module.exports = __webpack_public_path__ + "static/media/wrong_columns.3ba5abdf.png";